import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import SLAModal from "./SLAModal";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  toggleBtn: {
    backgroundColor: "#fff",
    color: "#077F83",
    border: "1px solid #077F83",
    padding: "5px 20px",
    borderRadius: "5px 0px 0px 5px",
    "& + $toggleBtn": {
      borderRadius: "0px 5px 5px 0px",
    },

    "&.active": {
      backgroundColor: "#077F83",
      color: "#fff",
    },
  },
  large: {
    width: theme.spacing(13),
    height: theme.spacing(13),
  },
}));

const SLA = (props) => {
  const classes = useStyles();
  const { SLAData, fetchSLADetail } = props;

  const [userData, setUserData] = useState({ organisation: "" });
  const [SLAModalFlag, setSLAModalFlag] = useState(false);
  const [currentRowSelection, setCurrentRowSelection] = useState(undefined);
  const [labelFlag, setLabelFlag] = useState("");

  const onChangeItem = (selectedItemValue) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };

  function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" {...props} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            variant="caption"
            component="div"
            color="textSecondary"
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box py={3}>
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{
          marginTop: 20,
          borderWidth: 1,
          borderColor: "#ddd",
          borderStyle: "solid",
          padding: 16,
        }}
      >
        <Grid item xs={3}>
          <Typography variant="h2" style={{ color: "#077F83" }}>
            <Box fontWeight="fontWeightBold">Description</Box>
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="h2" style={{ color: "#077F83" }}>
            <Box fontWeight="fontWeightBold">Measure</Box>
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h2" style={{ color: "#077F83" }}>
            <Box fontWeight="fontWeightBold">Did we meet the measure?</Box>
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h2" style={{ color: "#077F83" }}>
            <Box fontWeight="fontWeightBold">
              Were there exceptional circumstances?
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="h2" style={{ color: "#077F83" }}>
            <Box fontWeight="fontWeightBold">Exceptions</Box>
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="h2" style={{ color: "#077F83" }}>
            <Box fontWeight="fontWeightBold">Edit</Box>
          </Typography>
        </Grid>
      </Grid>
      <Box>
        {SLAData?.map((data, index) => {
          return (
            <>
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{
                  borderWidth: 1,
                  borderColor: "#ddd",
                  borderStyle: "solid",
                  padding: 16,
                }}
              >
                <Grid item xs={3}>
                  <Typography
                    variant="h2"
                    style={{
                      color: "#4D4F5C",
                      paddingRight: "40px",
                      textAlign: "justify",
                    }}
                  >
                    <Box>{data?.description || "-"}</Box>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    variant="h2"
                    style={{
                      color: "#4D4F5C",
                      paddingRight: "40px",
                      textAlign: "justify",
                    }}
                  >
                    <Box>{data?.measure || "-"}</Box>
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="h2" style={{ color: "#4D4F5C" }}>
                    <Grid item xs="12">
                      <Box>
                        <Box
                          component="span"
                          className={classes.toggleBtn}
                          style={{
                            backgroundColor:
                              data?.measure_meet == "true" ? "#077F83" : "#fff",
                            color:
                              data?.measure_meet == "true" ? "#fff" : "#077F83",
                          }}
                        >
                          Yes
                        </Box>
                        <Box
                          component="span"
                          className={classes.toggleBtn}
                          style={{
                            backgroundColor:
                              data?.measure_meet == "false"
                                ? "#077F83"
                                : "#fff",
                            color:
                              data?.measure_meet == "false"
                                ? "#fff"
                                : "#077F83",
                          }}
                        >
                          No
                        </Box>
                      </Box>
                    </Grid>
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="h2" style={{ color: "#4D4F5C" }}>
                    <Grid item xs="12">
                      <Box>
                        <Box
                          component="span"
                          className={classes.toggleBtn}
                          style={{
                            backgroundColor:
                              data?.exceptional_circumstances == "true"
                                ? "#077F83"
                                : "#fff",
                            color:
                              data?.exceptional_circumstances == "true"
                                ? "#fff"
                                : "#077F83",
                          }}
                        >
                          Yes
                        </Box>
                        <Box
                          component="span"
                          className={classes.toggleBtn}
                          style={{
                            backgroundColor:
                              data?.exceptional_circumstances == "false"
                                ? "#077F83"
                                : "#fff",
                            color:
                              data?.exceptional_circumstances == "false"
                                ? "#fff"
                                : "#077F83",
                          }}
                        >
                          No
                        </Box>
                      </Box>
                    </Grid>
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant="h2" style={{ color: "#4D4F5C" }}>
                    <Box>
                      <Button
                        style={{
                          textTransform: "none",
                          marginLeft: "-8px",
                        }}
                        color="primary"
                        onClick={() => {
                          setLabelFlag("viewExceptionsDetail");
                          setCurrentRowSelection(data);
                          setSLAModalFlag(true);
                        }}
                      >
                        View details
                      </Button>
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant="h2" style={{ color: "#4D4F5C" }}>
                    <Box
                      onClick={() => {
                        setLabelFlag("editAssignmentSummary");
                        setCurrentRowSelection(data);
                        setSLAModalFlag(true);
                      }}
                    >
                      <EditIcon
                        style={{
                          fontSize: 20,
                          color: "#757575",
                          cursor: "pointer",
                        }}
                      />
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
              <Divider />
            </>
          );
        })}
      </Box>

      {SLAModalFlag && labelFlag == "editAssignmentSummary" && (
        <SLAModal
          {...props}
          labelFlag={labelFlag}
          fetchAPI={fetchSLADetail}
          currentRowSelection={currentRowSelection}
          isOpen={SLAModalFlag}
          onClose={() => {
            setSLAModalFlag(false);
          }}
        />
      )}

      {SLAModalFlag && labelFlag == "viewExceptionsDetail" && (
        <SLAModal
          {...props}
          labelFlag={labelFlag}
          currentRowSelection={currentRowSelection}
          isOpen={SLAModalFlag}
          onClose={() => {
            setSLAModalFlag(false);
          }}
        />
      )}
    </Box>
  );
};

export default SLA;
